import {atom} from "recoil";

const heardFrom = atom(({
    key: "accountHeardFrom",
    default: '' 
}));

export default heardFrom;